const ActionTypes = {
    SET_USER: 'SET_USER',
    SET_STATS: 'SET_STATS',
    SET_ACCOUNTS: 'SET_ACCOUNTS',
    SET_FILENAMES: 'SET_FILENAMES',
    SET_SIGNUP_STEP: 'SET_SIGNUP_STEP',
    SET_PACKAGE_TYPE: 'SET_PACKAGE_TYPE',
    SET_SELECTED_USER : 'SET_SELECTED_USER',
    SET_USAGE_TYPE : 'SET_USAGE_TYPE',
    SET_BLOCKED_EMAILS : 'SET_BLOCKED_EMAILS',
    SET_PHISHING_URLS : 'SET_PHISHING_URLS',

    SET_SIGNUP_ERROR : 'SET_SIGNUP_ERROR',


    ADD_USER : 'ADD_USER',
    UPDATE_DOWN: 'UPDATE_DOWN',
    UPDATE_PROCESS: 'UPDATE_PROCESS',
    UPDATE_BLOCKED: 'UPDATE_BLOCKED',
    UPDATE_ACCOUNT: 'UPDATE_ACCOUNT',
    UPDATE_BLOCKED_EMAIL: 'UPDATE_BLOCKED_EMAIL',
    UPDATE_PHISHING_URL: 'UPDATE_PHISHING_URL',

    SET_TOAST : 'SET_TOAST',
    CLEAR_TOAST : 'CLEAR_TOAST',

    SET_COUPON : 'SET_COUPON'

}

export default ActionTypes